import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { FormSharedModule } from '../form-shared.module';
import { BarraSuperiorComponent } from './barra-superior/barra-superior.component';
import { PiePaginaComponent } from './pie-pagina/pie-pagina.component';
import { BarraLateralContenidoComponent } from './barra-lateral/barra-lateral-contenido.component';
import { BarraLateralComponent } from './barra-lateral/barra-lateral.component';
import { BarraLateralSubmenuComponent } from './barra-lateral/barra-lateral-submenu.component';
import { BarraLateralMenuComponent } from './barra-lateral/barra-lateral-menu.component';
import { PlantillaComponent } from './plantilla.component';
import { AdjuntoService } from '../../_services/adjunto.service';
import { RolFuncionalitiesServices } from '../../_services/rol-funcionalidad.service';
import {NgStyle} from "@angular/common";
import {ScrollPanelModule} from "primeng/scrollpanel";


@NgModule( {
  declarations: [
    BarraSuperiorComponent,
    PiePaginaComponent,
    BarraLateralContenidoComponent,
    BarraLateralComponent,
    BarraLateralSubmenuComponent,
    BarraLateralMenuComponent,
    PlantillaComponent
  ],
  imports: [SharedModule, FormSharedModule, NgStyle, ScrollPanelModule],
  exports: [
    BarraSuperiorComponent,
    PiePaginaComponent,
    BarraLateralContenidoComponent,
    BarraLateralComponent,
    BarraLateralSubmenuComponent,
    BarraLateralMenuComponent,
    PlantillaComponent
  ],
  providers: [ AdjuntoService, RolFuncionalitiesServices ]
} )

export class PlantillaModule {
}
